(function () {
  function normalizeMediaId(id) {
    if (!id) return "";
    const tail = String(id).split("-").pop();
    return /^\d+$/.test(tail) ? tail : String(id);
  }

  document.addEventListener(
    "click",
    function (e) {
      const link = e.target.closest(".productView-thumbnail-link");
      if (!link) return;

      // Only on product pages / when main gallery exists
      const scope = link.closest(".halo-productView") || document;
      const main = scope.querySelector(".productView-nav.slick-initialized");
      if (!main || !window.jQuery) return;

      const rawId = normalizeMediaId(link.dataset.mediaId);
      if (!rawId) return;

      const $main = window.jQuery(main);

      // Find target slick slide by matching media-id inside slides
      let slickIndex = null;

      $main.find(".slick-slide").each(function () {
        const node = this.querySelector("[data-media-id]");
        if (!node) return;

        const slideId = normalizeMediaId(node.getAttribute("data-media-id"));
        if (String(slideId) === String(rawId)) {
          slickIndex = window.jQuery(this).data("slick-index");
          return false; // break
        }
      });

      // If we can't map it, let Halo handle it (no clash)
      if (slickIndex === null || slickIndex === undefined) return;

      // STOREFRONT-8F: if Slick isn't initialised on $main yet, don't hijack the
      // click (that threw "$main.slick is not a function") — let Halo's own handler
      // deal with it by returning before preventDefault.
      if (!$main || typeof $main.slick !== "function") return;

      // We can handle it reliably -> switch
      e.preventDefault();
      $main.slick("slickGoTo", slickIndex);
    },
    true
  );
})();